import { Column } from "@bridgesplit/ui";
import { TEST_IDS } from "app/constants";

import ManualWindCollateral from "./ManualWindCollateral";
import ManualWindPrincipal from "./ManualWindPrincipal";
import WindCta from "../WindCta";
import WindNestedStats from "../WindNestedStats";

export function ManualWindCard() {
    return (
        <Column spacing={3} data-testid={TEST_IDS.MANUAL_WIND_CARD}>
            <ManualWindCollateral />
            <ManualWindPrincipal />
            <WindNestedStats />
            <WindCta />
        </Column>
    );
}
